"use strict";

// no jquery for this, from https://stackoverflow.com/a/1038781/4504073
function getWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

function getHeight() {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.documentElement.clientHeight
  );
}

/*!
 * Get next sibling of an element that matches a test condition
 * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}     elem     The element
 * @param  {Function} callback The test condition
 * @return {Node}              The sibling
 */
site.getNextSibling = function(elem, callback) {

	// Get the next sibling element
	let sibling = elem.nextElementSibling;

	// If there's no callback, return the first sibling
	if (!callback || typeof callback !== 'function') return sibling;

	// If the sibling matches our test condition, use it
	// If not, jump to the next sibling and continue the loop
	let index = 0;
	while (sibling) {
		if (callback(sibling, index, elem)) return sibling;
		index++;
		sibling = sibling.nextElementSibling;
	}

}



// var sm = 768;
// var lg = 1152;
site.breakSm = 768;
site.breakMd = 1820;
// site.breakLg = 1925;
site.isMobile;
site.isDesktop;
site.isMassive;
site.isTransitioningToMobile = false;
site.isTransitioningToDesktop = false;
site.isTransitioningToMassive = false;

site.isShowingEverything = false;
site.isShowingTransportation = false;
site.isShowingMarkers = false;
site.isHidingLabels = false;

site.screenWidth = getWidth();
site.screenHeight = getHeight();

site.navbar = document.getElementById('#navbar'); // logo switching for nav
site.$projectSliderWrapper = document.querySelector('.project-slider-wrapper');
site.lockBody;
site.unlockBody;

site.googleMap; // global so can set zoom level on mobile
site.markers = []; // save for clustering
site.mapStyleControl = document.getElementById('style-selector-control');

// home
site.isLayoutStamped = true; // flag for mobile layout
site.firstClickActivated = false;
// site.colors = {
//     blueline: '#003da5',
//     greenline: '#00843d',
//     redline: '#da291c',
//     orangeline: '#ed8b00',
//     bus: '#ffc72c',
//     lightgray: '#888b8c',
//     palette: {
//         purple: '#4d4f96',
//         blue: '#249fda',
//         red: '#ee2e24',
//         green: '#2bb673',
//         teal: '#88d1d1',
//         orange: '#f15a31',
//         gold: '#ffd620',
//         pink: '#f17db1'
//         // m_green: '#68a562'
//         // l_green: '#89bc76'
//     }
// };

page.glide; // global so can reset

// // explore page filtering global so can use after filtering
// if(document.getElementById('explore-page')) {
//   // console.log('page.exploreList', page.exploreList);
//   // get info box
//   // let infoBox = revealList.querySelector('.info-box');
//   page.exploreList = document.querySelector('.explore-list');
//   page.infoBox = page.exploreList.querySelector('.info-box');
//   page.businesses = document.querySelectorAll('.business');
// }

/**********
* Check Mobile every time resize the browser
**********/
// set mobile flag
function checkMobile() {
  site.screenWidth = getWidth();
  // only do it if already not mobile or initial
  if (site.screenWidth < site.breakSm) {

      // set flags
      site.isMobile = true;
      site.isTablet = false;
      site.isDesktop = false;
      site.isMassive = false

  // only check if already mobile and bigger
  // Tablet
  } else if ((site.screenWidth > site.breakSm) && (site.screenWidth <= site.breakMd)) {

      // set flags
      site.isMobile = false;
      site.isTablet = true;
      site.isDesktop = false;
      site.isMassive = false;

  // Desktop
  } else if ((site.screenWidth > site.breakMd) && (site.screenWidth <= site.breakLg)) {

      // set flags
      site.isMobile = false;
      site.isTablet = false;
      site.isDesktop = true;
      site.isMassive = false;

  } else if (site.screenWidth > site.breakLg) {

      // set flag
      site.isMobile = false;
      site.isTablet = false;
      site.isDesktop = false;
      site.isMassive = true;
  }
}

checkMobile(); // initial
